import get from "lodash.get"
import { useState, useEffect } from "react"
import { AppState } from "../../../state/store"
import { VehicleDetailsResponse } from "../vehicleDetails/types"
import { getValuationRequest } from "./request"
import { mapVehicleType } from "../../../state/selectors/vehicleType"
import { getLeadWithValuationRequest } from "../leadWithValuation/request"

export type VehicleData = {
  capId: number
  capCode: string
  mileage: number
  dateRegistered: string
  condition: number
  vehicleType: number
  history: {
    push: Function
  }
}

export interface DealershipData {
  DealershipName: string
  DealershipGuid: string
}

export type CustomerData = {
  FirstName: string
  LastName: string
  Email: string
  Mobile?: string
  Postcode: string
  history: {
    push: Function
  }
  Landline?: string
}

export type VehicleBasic = {
  vehicleDetails: object
}

export const mapCondition = (condition: string): number => {
  switch (condition) {
    case "Excellent":
      return 1
    case "Good":
      return 2
    case "Average":
      return 3
    case "Below average":
      return 4
    default:
      return 0
  }
}

export const getVehicleDetails = (vehicleDetails: VehicleDetailsResponse | any) => {
  const { capCode, capId, vehicleType } = get(
    vehicleDetails,
    "requestResultsType.asset.supplementaryAssetData.cap",
    {}
  )
  const {
    keyDates: { firstRegistered: { date: dateRegistered = "" } = {} } = {},
  } = get(vehicleDetails, "requestResultsType.asset.primaryAssetData.dvla", {})

  return {
    capId,
    capCode,
    vehicleType,
    dateRegistered,
  }
}

export const useGetValuation = (
  addVehicleValuation: Function,
  handleError: (error: Error) => any
) => {
  const [vehicleData, setVehicleData] = useState<any | null>(null)
  const [vehicleDataForLead, setVehicleDataForLead] = useState<any | null>(null)
  const [group, setGroup] = useState<number | null>(null)
  const [customerData, setCustomerData] = useState<CustomerData | null>()
  const [dealershipData, setDealershipData] = useState<DealershipData | null>(
    null
  )
  const [vehicleBasic, setVehicleBasic] = useState<VehicleBasic>()

  useEffect(() => {
    if (
      vehicleData &&
      vehicleData.history &&
      vehicleData.history.push &&
      group
    ) {
      if (!vehicleData.capCode && !vehicleData.capId) {
        vehicleData.history.push("/vehicle-not-found")
      } else {
        if (
          customerData &&
          vehicleDataForLead &&
          dealershipData &&
          vehicleBasic
        )
          getValuationRequest(vehicleData, group).then((data) => {
            addVehicleValuation(data?.data)
            const { vehicleDetails } = vehicleBasic
            const newVehicleData = {
              ...vehicleDataForLead,
              HpiBasicLookup: vehicleDetails,
            }
            getLeadWithValuationRequest(
              data?.data,
              customerData,
              newVehicleData,
              dealershipData
            ).then((response: any) => {
              if (response.message === "Success") {
                customerData.history.push(`/call-requested`)
              } else {
                customerData.history.push(`/valuation-request-not-processed`)
              }
            })
            .catch(() => {
              customerData.history.push(`/valuation-request-not-processed`)
            })
          })
        .catch(() => {
          customerData.history.push(`/valuation-request-not-processed`)
        })
      }
    }
    // eslint-disable-next-line
  }, [vehicleData, customerData, vehicleDataForLead, dealershipData])

  return (
    {
      vehicleDetails,
      mileage,
      vehicleCondition,
      groupId,
      registration,
      appointmentDetails: { dealership },
      dealershipGuid,
      contactDetails: { firstName, lastName, email, contactNumber, postcode, countryCode },
    }: AppState,
    history: any
  ) => {
    const convertedMileageToString = mileage.toString().split(",").join("")

    const isUkMobile = countryCode === "+44" && /^((07[0-9]{9}))$/.test(contactNumber)
    const isIrishMobile = countryCode === "+353" && /^((08[0-9]{6,13}))$/.test(contactNumber)
    const customerData = {
      FirstName: firstName,
      LastName: lastName,
      Email: email,
      Mobile: (isUkMobile || isIrishMobile ? contactNumber : ""),
      Landline: (!isUkMobile && !isIrishMobile ? contactNumber : ""),
      Postcode: postcode,
      history
    }

    const { capId, capCode, dateRegistered, vehicleType } =
      getVehicleDetails(vehicleDetails)

    setGroup(groupId)
    setVehicleData({
      capId: parseInt(capId),
      capCode: capCode,
      mileage: parseInt(convertedMileageToString),
      dateRegistered: dateRegistered,
      condition: mapCondition(vehicleCondition),
      vehicleType: mapVehicleType(vehicleType),
      history,
    })
    setVehicleBasic({ vehicleDetails })
    setVehicleDataForLead({
      Registration: registration,
      Mileage: parseInt(convertedMileageToString),
      Condition: mapCondition(vehicleCondition),
    })
    setCustomerData(customerData)  
    setDealershipData({
      DealershipName: dealership,
      DealershipGuid: dealershipGuid,
    })
  }
}
